var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_34146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_34146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.333333H-0.95026L-0.208232 0.26029L3.66667 3.36021V4.08827L-0.1849 6.65598L-0.333333 6.75494V6.93333V7.46667V8.04701L0.167957 7.75459L4.66154 5.13333H5.61336L9.48374 7.71358C9.56826 7.76993 9.66757 7.8 9.76915 7.8C10.2555 7.8 10.4704 7.18752 10.0906 6.88368L6.61905 4.10646V3.37839L10.3222 0.909639C10.5076 0.785995 10.619 0.577841 10.619 0.354939V0V-0.580346L10.1178 -0.287926L5.62417 2.33333H4.67235L0.756329 -0.27735L0.672354 -0.333333H0.571429H0Z",
    fill: "#FF2E3B",
    stroke: "white",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.66667V4.8H4V7.33333C4 7.70152 4.29848 8 4.66667 8H5.61905C5.98724 8 6.28571 7.70152 6.28571 7.33333V4.8H10.1905C10.5587 4.8 10.8571 4.50152 10.8571 4.13333V3.33333C10.8571 2.96514 10.5587 2.66667 10.1905 2.66667H6.28571V0H4V2.66667H0Z",
    fill: "url(#paint0_linear_238_34146)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.2H4.57143V2.66667V0H5.71429V2.66667V3.2H10.2857V4.26667H5.71429V4.8V7.46667H4.57143V4.8V4.26667H0V3.2Z",
    fill: "url(#paint1_linear_238_34146)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14275 13.0666L4.13512 13.5611L4.32756 12.5138L3.51237 11.7722L4.63894 11.6194L5.14275 10.6666L5.64657 11.6194L6.77313 11.7722L5.95794 12.5138L6.15038 13.5611L5.14275 13.0666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 13.8667L16.3347 14.0876L16.5714 13.3334L16.3347 12.5791L17.1429 12.8001L17.951 12.5791L17.7143 13.3334L17.951 14.0876L17.1429 13.8667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 3.7333L16.3347 3.95421L16.5714 3.19997L16.3347 2.44572L17.1429 2.66663L17.951 2.44572L17.7143 3.19997L17.951 3.95421L17.1429 3.7333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5713 6.93337L19.7632 7.15429L19.9999 6.40004L19.7632 5.64579L20.5713 5.86671L21.3794 5.64579L21.1428 6.40004L21.3794 7.15429L20.5713 6.93337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7144 8.00002L12.9063 8.22094L13.143 7.46669L12.9063 6.71244L13.7144 6.93336L14.5225 6.71244L14.2858 7.46669L14.5225 8.22094L13.7144 8.00002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8571 9.33333L18.453 9.44378L18.5714 9.06666L18.453 8.68953L18.8571 8.79999L19.2611 8.68953L19.1428 9.06666L19.2611 9.44378L18.8571 9.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_34146",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_238_34146",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 7.46667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0D1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.d0c5a893c31d0e183c9e5575bd7954b0.svg";
export { ForwardRef as ReactComponent };